import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, IconButton, Typography } from '@mui/material';
import { CancelIcon } from '@sharedCR/coreDesignSystem/icons';

import { IconSize } from 'constants/coreDesignSystem';

import { stopFollowingAction } from 'store/presence/actions';
import { selectFollowedUser, selectIsFollowing } from 'store/presence/selectors';

import {
  bannerContainerStyles,
  bannerTextStyles,
  closeButtonStyles,
} from './FollowModeBanner.styles';
import { FollowModeBannerTestIds } from './FollowModeBanner.testIds';

const FollowModeBanner = () => {
  const dispatch = useDispatch();

  const isFollowing = useSelector(selectIsFollowing);
  const followedUser = useSelector(selectFollowedUser);

  const onStopFollowing = useCallback(() => {
    dispatch(stopFollowingAction());
  }, [dispatch]);

  if (!isFollowing) {
    return null;
  }

  const displayName = followedUser
    ? `${followedUser.firstName} ${followedUser.lastName}`.trim()
    : 'Unknown';

  return (
    <Box sx={bannerContainerStyles} onClick={onStopFollowing}>
      <Typography sx={bannerTextStyles} variant="bold14">
        Following {displayName}
      </Typography>
      <Typography sx={bannerTextStyles} variant="regular14">
        — click to stop
      </Typography>
      <IconButton
        disableRipple
        data-testid={FollowModeBannerTestIds.STOP_BUTTON}
        size="small"
        sx={closeButtonStyles}
      >
        <CancelIcon size={IconSize[16]} />
      </IconButton>
    </Box>
  );
};

export default memo(FollowModeBanner);
